import ProfileAvatar from '../../my-page/components/ProfileAvatar';
import { commonFontFamily } from '../../../constants/BettieGradientColor';
import type { components } from '@pocapan/shared/types/schema';

type FanLetter = components['schemas']['ApiV1FanLetter'];

interface FanLetterCardHeaderProps {
  fanLetter: FanLetter;
}

const FanLetterCardHeader = ({ fanLetter }: FanLetterCardHeaderProps) => {
  return (
    <div className="flex items-end justify-between pb-[10px]">
      <div className="flex items-end gap-[8px]">
        <img src="/assets/bettie/letter_dear_image.png" alt="Dear" className="w-[82px] h-[43px]" />
        <p className="text-[16px] text-text-main-lv3" style={commonFontFamily}>
          {fanLetter.userNickname}
        </p>
      </div>
      {fanLetter?.bettiePictureUrl ? (
        <div className="relative">
          <img
            src={fanLetter?.bettiePictureUrl}
            alt="profile"
            className="w-[79px] h-[79px] rounded-full mix-blend-hard-light"
            style={{
              filter: 'brightness(80%) grayscale(100%) contrast(50%)'
            }}
          />
          <img
            src={fanLetter?.bettiePictureUrl}
            alt="profile"
            className="w-[85px] h-[85px] rounded-full mix-blend-hard-light absolute top-0 left-0"
            style={{
              filter: 'grayscale(100%) blur(6px)'
            }}
          />
        </div>
      ) : (
        <ProfileAvatar widthAndHeight="79px" svgWidthAndHeight="60px" />
      )}
    </div>
  );
};

export default FanLetterCardHeader;
